/* ==========================================================================
   PanelPet > Input
   ========================================================================== */

/* Modules */
const InputClient = require('../../../input/client/js');

/* Init Checkbox Toggle */
function initInput(selector, configuration, instance) {
    /* Return the input instance */
    return InputClient(selector, {
        ...configuration,
        onChange: [input => configuration.onChangeInput(input, instance)]
    });
}

module.exports = {
    initInput
};
